// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".float-left[data-v-5e80f0a4] {\n  float: left;\n}\n.float-right[data-v-5e80f0a4] {\n  float: right;\n}", ""]);
// Exports
module.exports = exports;
